export const LoadingDots = () => {
    return (
        <div className="flex items-center justify-center space-x-1">
            <div className="w-2 h-2 bg-primary-blue rounded-full animate-bounce"></div>
            <div className="w-2 h-2 bg-primary-blue rounded-full animate-bounce delay-75"></div>
            <div className="w-2 h-2 bg-primary-blue rounded-full animate-bounce delay-150"></div>
        </div>
    );
};
